/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import {
  Button,
  Container,
  Grid,
  Dropdown,
  Divider,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { decodeSearch } from '../../../utils/url';
import LoadImage from '../../../components/LoadImage';
import NavBar from '../../../components/NavBar';
import LoanAmount from '../../../components/LoanAmount';
import CurrencySymbol from '../../../components/CurrencySymbol';
import { flashErrorMessage } from '../../../actions/flash';
import { fetchM } from '../../../actions/fetchM';
import { namespaces, TRANSLATION_FILES } from '../../../constants/translation';
import { translateModels } from '../../../utils/translation';
import { getAreaLabel, getMissingAreaLabel } from '../../../utils/areaLabel';
import { isCountryVietnam } from '../../../constants/countries';

class UnitsCompare extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    id: PropTypes.string,
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }),
    project: PropTypes.shape({
      projectPictures: PropTypes.array,
      gps: PropTypes.string,
      maOwnerCompanyBranchID: PropTypes.number,
    }),
    loading: PropTypes.bool,
    auth: PropTypes.shape({
      isBranchLeader: PropTypes.bool,
      isBranchLeaderSupervisorII: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      isSiteplan: PropTypes.bool,
      allowEditUnitPrice: PropTypes.bool,
      allowEditUnitDetails: PropTypes.bool,
    }),
    t: PropTypes.func,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  })
  static getPropsToState = (props) => {
    const loading = props.loading;
    const isMobile = window.innerWidth < 768;
    const isMediumScreen = window.innerWidth <= 990 && window.innerWidth >= 767;
    const limit = props.limit;
    const query = decodeSearch(props.location.search);
    return {
      isMobile,
      isMediumScreen,
      loading,
      limit,
      query,
    };
  }
  constructor(props) {
    super(props);
    const state = UnitsCompare.getPropsToState(props);
    this.state = {
      ...state,
      selectedUnit: {},
    };
  }
  componentDidMount() {
    window.addEventListener('resize', this.handleResize, false);
    this.fetchDetailedBulkProjectUnits();
  }
  componentWillReceiveProps(nextProps) {
    const state = UnitsCompare.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  setInitialUnitID = () => {
    const { projectUnits } = this.state;
    // set initial selected unit id
    if (this.state && projectUnits) {
      const selectedUnit = {};

      projectUnits.map((unit, idx) => {
        const result = {
          [`selectUnit${idx + 1}`]: unit.id,
        };
        Object.assign(selectedUnit, result);
      });
      this.setState({
        selectedUnit: {
          ...selectedUnit,
        },
      });
    }
  }
  getOptionData = (data) => {
    if (data) {
      const DpOptions = data.map(unit => ({
        text: unit.reference,
        value: unit.id,
      }));
      return DpOptions;
    }
    return null;
  }
  async fetchDetailedBulkProjectUnits() {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${this.props.id}/units/detailed/?statusID=new`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const data = await res.json();
      if (data) {
        this.setState({ projectUnits: data });
        this.setInitialUnitID();
      }
    }
    await this.setLoading(false);
  }
  handleResize = () => {
    const windowWidth = window.innerWidth;
    const isMobile = windowWidth < 768;
    const isMediumScreen = window.innerWidth <= 990 && window.innerWidth >= 767;
    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile });
    }
    if (isMediumScreen !== this.state.isMediumScreen) {
      this.setState({ isMediumScreen });
    }
  }
  handleOnChange = (event, { value, name }) => {
    const { selectedUnit } = this.state;
    selectedUnit[name] = value;
    this.setState({ selectedUnit });
  }
  renderDropdown = () => {
    const { t } = this.props;
    const { projectUnits, selectedUnit, isMobile } = this.state;
    if (projectUnits) {
      return (
        <Grid.Row
          centered
          columns={
            isMobile ? 2
            : projectUnits.length >= 3 ?
              3 : 2
          }
        >
          <Grid.Column>
            <Dropdown
              placeholder={t('Select Unit', { ns: TRANSLATION_FILES.screens })}
              name="selectUnit1"
              fluid
              selection
              value={typeof selectedUnit.selectUnit1 === 'object' ? selectedUnit.selectUnit1.id : selectedUnit.selectUnit1}
              options={this.getOptionData(projectUnits)}
              onChange={(event, value) => this.handleOnChange(event, value)}
            />
          </Grid.Column>
          <Grid.Column>
            <Dropdown
              placeholder={t('Select Unit', { ns: TRANSLATION_FILES.translation })}
              name="selectUnit2"
              fluid
              selection
              value={typeof selectedUnit.selectUnit2 === 'object' ? selectedUnit.selectUnit2.id : selectedUnit.selectUnit2}
              options={this.getOptionData(projectUnits)}
              onChange={(event, value) => this.handleOnChange(event, value)}
            />
          </Grid.Column>
          {
            projectUnits.length >= 3 && !isMobile &&
              <Grid.Column only="computer">
                <Dropdown
                  placeholder={t('Select Unit', { ns: TRANSLATION_FILES.translation })}
                  name="selectUnit3"
                  fluid
                  selection
                  value={typeof selectedUnit.selectUnit3 === 'object' ? selectedUnit.selectUnit3.id : selectedUnit.selectUnit3}
                  options={this.getOptionData(projectUnits)}
                  onChange={(event, value) => this.handleOnChange(event, value)}
                />
              </Grid.Column>
          }
        </Grid.Row>
      );
    }
    return null;
  }
  renderContent = () => {
    const { t } = this.props;
    const { projectUnits, selectedUnit, isMobile, isMediumScreen } = this.state;
    Object.keys(selectedUnit).forEach((key) => {
      projectUnits.filter((unit) => {
        if (unit.id === selectedUnit[key]) {
          selectedUnit[key] = unit;
          return unit;
        }
        return null;
      });
    });
    const { selectUnit1, selectUnit2, selectUnit3 } = selectedUnit;
        // check layout spec has bed field
    const checkLayout1Bed = selectUnit1 && selectUnit1.projectUnitLayout.specifications ? selectUnit1.projectUnitLayout.specifications.some(spec => spec.shortName === 'Bed') : '';
    const checkLayout2Bed = selectUnit2 && selectUnit2.projectUnitLayout.specifications ? selectUnit2.projectUnitLayout.specifications.some(spec => spec.shortName === 'Bed') : '';
    const checkLayout3Bed = selectUnit3 && selectUnit3.projectUnitLayout.specifications ? selectUnit3.projectUnitLayout.specifications.some(spec => spec.shortName === 'Bed') : '';

        // check layout spec has bath field
    const checkLayout1Bath = selectUnit1 && selectUnit1.projectUnitLayout.specifications ? selectUnit1.projectUnitLayout.specifications.some(spec => spec.shortName === 'Bath') : '';
    const checkLayout2Bath = selectUnit2 && selectUnit2.projectUnitLayout.specifications ? selectUnit2.projectUnitLayout.specifications.some(spec => spec.shortName === 'Bath') : '';
    const checkLayout3Bath = selectUnit3 && selectUnit3.projectUnitLayout.specifications ? selectUnit3.projectUnitLayout.specifications.some(spec => spec.shortName === 'Bath') : '';

            // check layout spec bed amount
    const checkLayout1BedAmount = selectUnit1 && selectUnit1.projectUnitLayout.specifications ? selectUnit1.projectUnitLayout.specifications.filter(spec => spec.shortName === 'Bed').length : '';
    const checkLayout2BedAmount = selectUnit2 && selectUnit2.projectUnitLayout.specifications ? selectUnit2.projectUnitLayout.specifications.filter(spec => spec.shortName === 'Bed').length : '';
    const checkLayout3BedAmount = selectUnit3 && selectUnit3.projectUnitLayout.specifications ? selectUnit3.projectUnitLayout.specifications.filter(spec => spec.shortName === 'Bed').length : '';

    // check layout spec bath amount
    const checkLayout1BathAmount = selectUnit1 && selectUnit1.projectUnitLayout.specifications ? selectUnit1.projectUnitLayout.specifications.filter(spec => spec.shortName === 'Bath').length : '';
    const checkLayout2BathAmount = selectUnit2 && selectUnit2.projectUnitLayout.specifications ? selectUnit2.projectUnitLayout.specifications.filter(spec => spec.shortName === 'Bath').length : '';
    const checkLayout3BathAmount = selectUnit3 && selectUnit3.projectUnitLayout.specifications ? selectUnit3.projectUnitLayout.specifications.filter(spec => spec.shortName === 'Bath').length : '';

    if (projectUnits && selectedUnit) {
      return (
        <Grid centered columns={2} className="compare_content">
          <Grid.Row
            centered
            columns={
              isMobile ? 2
              : projectUnits.length >= 3 ?
                  isMediumScreen ?
                  2 : 3
                : 2
            }
          >
            <Grid.Column>
              {
                selectUnit1 ?
                  <LoadImage
                    fluid
                    cover="vertical long"
                    centered
                    notFoundNode={
                      <div>
                        <p>{t('No cover picture found')}.</p>
                        <Button
                          as={Link}
                          primary compact
                          to={`/projects/${this.props.id}/layouts/${selectUnit1.projectUnitLayoutID}/pictures/`}
                          content={t('Click here to add')}
                        />
                      </div>
                    }
                    picture={
                      selectUnit1.projectUnitLayout.pictures ?
                      selectUnit1.projectUnitLayout.pictures.find((pic) => {
                        if (pic.type === 'unit_layout') {
                          return pic.key;
                        }
                        return null;
                      })
                    : null
                  }
                    pictureSize={100}
                  />
                : null
              }
            </Grid.Column>
            <Grid.Column>
              {
                selectUnit2 ?
                  <LoadImage
                    fluid
                    cover="vertical long"
                    centered
                    notFoundNode={
                      <div>
                        <p>{t('No cover picture found')}.</p>
                        <Button
                          as={Link}
                          primary compact
                          to={`/projects/${this.props.id}/layouts/${selectUnit2.projectUnitLayoutID}/pictures/`}
                          content={t('Click here to add')}
                        />
                      </div>
                    }
                    picture={
                      selectUnit2.projectUnitLayout.pictures ?
                      selectUnit2.projectUnitLayout.pictures.find((pic) => {
                        if (pic.type === 'unit_layout') {
                          return pic.key;
                        }
                        return null;
                      })
                      : null
                    }
                    pictureSize={100}
                  />
                : null
              }
            </Grid.Column>
            {
                projectUnits.length >= 3 && !isMobile &&
                  <Grid.Column only="computer">
                    {
                      selectUnit3 ?
                        <LoadImage
                          fluid
                          centered
                          cover="vertical long"
                          notFoundNode={
                            <div>
                              <p>{t('No cover picture found')}.</p>
                              <Button
                                as={Link}
                                primary compact
                                to={`/projects/${this.props.id}/layouts/${selectUnit3.projectUnitLayoutID}/pictures/`}
                                content={t('Click here to add')}
                              />
                            </div>
                          }
                          picture={
                            selectUnit3.projectUnitLayout.pictures ?
                            selectUnit3.projectUnitLayout.pictures.find((pic) => {
                              if (pic.type === 'unit_layout') {
                                return pic.key;
                              }
                              return null;
                            })
                            : null
                          }
                          pictureSize={100}
                        />
                    : null
                  }
                  </Grid.Column>
              }
          </Grid.Row>
          <Grid.Row
            centered
            columns={
              isMobile ? 2
              : projectUnits.length >= 3 ?
                  isMediumScreen ?
                  2 : 3
                : 2
            }
            className="sizeRow"
          >
            <Divider horizontal>{t('Layout Specifications')}</Divider>
            <Grid.Column>
              {
                selectUnit1 &&
                selectUnit1.projectUnitLayout ?
                  <div>
                    <h1>{selectUnit1.projectUnitLayout.name || ''}</h1>
                    <small>{t('Layout Type')}</small>
                  </div>
                : <p className="noValue">{t('No layout type available', { ns: TRANSLATION_FILES.translation })}</p>
              }
            </Grid.Column>
            <Grid.Column>
              {
                selectUnit2 &&
                selectUnit2.projectUnitLayout ?
                  <div>
                    <h1>{selectUnit2.projectUnitLayout.name || ''}</h1>
                    <small>{t('Layout Type')}</small>
                  </div>
                : <p className="noValue">{t('No layout type available', { ns: TRANSLATION_FILES.translation })}</p>
              }
            </Grid.Column>
            {
              projectUnits.length >= 3 && !isMobile ?
                <Grid.Column only="computer">
                  {
                    selectUnit3 &&
                    selectUnit3.projectUnitLayout ?
                      <div className="sizeRow">
                        <h1>{selectUnit3.projectUnitLayout.name || ''}</h1>
                        <small>{t('Layout Type')}</small>
                      </div>
                    : <p className="noValue">{t('No layout type available', { ns: TRANSLATION_FILES.translation })}</p>
                  }
                </Grid.Column>
              : null
            }
            <Grid.Column>
              {
                selectUnit1 &&
                selectUnit1.projectUnitLayout &&
                selectUnit1.projectUnitLayout.specifications &&
                checkLayout1Bed ?
                  selectUnit1.projectUnitLayout.specifications.map((spec, idx) => (
                    spec.name.toLowerCase() === 'bedrooms' ?
                      <div className="specColumns" key={idx}>
                        <h1>
                          {spec.value || '0'}
                        </h1>
                        <p>{t('Bedroom')}</p>
                        <br />
                      </div>
                    : null
                  ))
                : <p className="noSpecAvailable">{t('No bedrooms available', { ns: TRANSLATION_FILES.translation })}</p>
              }
            </Grid.Column>
            <Grid.Column>
              {
                selectUnit2 &&
                selectUnit2.projectUnitLayout &&
                selectUnit2.projectUnitLayout.specifications &&
                checkLayout2Bed ?
                  selectUnit2.projectUnitLayout.specifications.map((spec, idx) => (
                    spec.name.toLowerCase() === 'bedrooms' ?
                      <div className="specColumns" key={idx}>
                        <h1>
                          {spec.value || '0'}
                        </h1>
                        <p>{t('Bedroom')}</p>
                        <br />
                      </div>
                    : null
                  ))
                : <p className="noSpecAvailable">{t('No bedrooms available', { ns: TRANSLATION_FILES.translation })}</p>
              }
            </Grid.Column>
            {
              projectUnits.length >= 3 && !isMobile ?
                <Grid.Column only="computer">
                  {
                    selectUnit3 &&
                    selectUnit3.projectUnitLayout &&
                    selectUnit3.projectUnitLayout.specifications &&
                    checkLayout3Bed ?
                      selectUnit3.projectUnitLayout.specifications.map((spec, idx) => (
                        spec.name.toLowerCase() === 'bedrooms' ?
                          <div className="specColumns" key={idx}>
                            <h1>
                              {spec.value || '0'}
                            </h1>
                            <p>{t('Bedroom')}</p>
                            <br />
                          </div>
                        : null
                      ))
                    : <p className="noSpecAvailable">{t('No bedrooms available', { ns: TRANSLATION_FILES.translation })}</p>

                  }
                </Grid.Column>
              : null
            }
            <Grid.Column>
              {
                selectUnit1 &&
                selectUnit1.projectUnitLayout &&
                selectUnit1.projectUnitLayout.specifications &&
                checkLayout1Bath ?
                  selectUnit1.projectUnitLayout.specifications.map((spec, idx) => (
                    spec.name.toLowerCase() === 'bathrooms' ?
                      <div className="specColumns" key={idx}>
                        <h1>
                          {spec.value || '0'}
                        </h1>
                        <p>{t('Bathroom')}</p>
                        <br />
                      </div>
                    : null
                  ))
                : <p className="noSpecAvailable">{t('No bathrooms available', { ns: TRANSLATION_FILES.translation })}</p>
              }
            </Grid.Column>
            <Grid.Column>
              {
                selectUnit2 &&
                selectUnit2.projectUnitLayout &&
                selectUnit2.projectUnitLayout.specifications &&
                checkLayout2Bath ?
                  selectUnit2.projectUnitLayout.specifications.map((spec, idx) => (
                    spec.name.toLowerCase() === 'bathrooms' ?
                      <div className="specColumns" key={idx}>
                        <h1>
                          {spec.value || '0'}
                        </h1>
                        <p>{t('Bathroom')}</p>
                        <br />
                      </div>
                    : null
                  ))
                : <p className="noSpecAvailable">{t('No bathrooms available', { ns: TRANSLATION_FILES.translation })}</p>
              }
            </Grid.Column>
            {
              projectUnits.length >= 3 && !isMobile ?
                <Grid.Column only="computer">
                  {
                    selectUnit3 &&
                    selectUnit3.projectUnitLayout &&
                    selectUnit3.projectUnitLayout.specifications &&
                    checkLayout3Bath ?
                      selectUnit3.projectUnitLayout.specifications.map((spec, idx) => (
                        spec.name.toLowerCase() === 'bathrooms' ?
                          <div className="specColumns" key={idx}>
                            <h1>
                              {spec.value || '0'}
                            </h1>
                            <p>{t('Bathroom')}</p>
                            <br />
                          </div>
                        : null
                      ))
                    : <p className="noSpecAvailable">{t('No bathrooms available', { ns: TRANSLATION_FILES.translation })}</p>
                  }
                </Grid.Column>
                : null
            }
          </Grid.Row>
          {this.renderBasicUnitInfo()}
          {this.renderPrice()}
          {this.renderPricingPackage()}
          {this.renderUnitSpec()}
        </Grid>
      );
    }
    return null;
  }
  renderBasicUnitInfo = () => {
    const { t } = this.props;
    const { project } = this.props;
    const { projectUnits, selectedUnit, isMobile, isMediumScreen } = this.state;
    const countryCode = this.props.auth && this.props.auth.company && this.props.auth.company.countryCode;
    const isVietnam = isCountryVietnam(countryCode);
    const { selectUnit1, selectUnit2, selectUnit3 } = selectedUnit;

    if (projectUnits && selectedUnit && project) {
      return (
        <Grid.Row
          centered
          columns={
            isMobile ? 2
              : projectUnits.length >= 3 ?
                  isMediumScreen ?
                  2 : 3
                : 2
            }
          className="basicInfo"
        >
          <Divider horizontal>{t('Basic Unit Info', { ns: TRANSLATION_FILES.translation })}</Divider>
          <Grid.Column>
            {
              selectUnit1 &&
              selectUnit1.size ?
                <div>
                  <h1>{selectUnit1.size || 0}
                    {
                      project.sizeSuffix === 'square_feet' ?
                        <small>{t('sqft', { ns: TRANSLATION_FILES.screens })}</small>
                      : project.sizeSuffix === 'square_metres' ?
                        <small>{isVietnam ? 'm²' : t('sqm', { ns: TRANSLATION_FILES.screens })}</small>
                        : ''
                    }
                  </h1>
                  <small>{getAreaLabel(t, countryCode)}</small>
                </div>
              : <p className="noValue">{getMissingAreaLabel(t, countryCode)}</p>
            }
          </Grid.Column>
          <Grid.Column>
            {
              selectUnit2 &&
              selectUnit2.size ?
                <div>
                  <h1>{selectUnit2.size || 0}
                    {
                      project.sizeSuffix === 'square_feet' ?
                        <small>{t('sqft', { ns: TRANSLATION_FILES.screens })}</small>
                      : project.sizeSuffix === 'square_metres' ?
                        <small>{isVietnam ? 'm²' : t('sqm', { ns: TRANSLATION_FILES.screens })}</small>
                        : ''
                    }
                  </h1>
                  <small>{getAreaLabel(t, countryCode)}</small>
                </div>
              : <p className="noValue">{getMissingAreaLabel(t, countryCode)}</p>
            }
          </Grid.Column>
          {
              projectUnits.length >= 3 && !isMobile ?
                <Grid.Column only="computer">
                  {
                    selectUnit3 &&
                    selectUnit3.size ?
                      <div>
                        <h1>{selectUnit3.size || 0}
                          {
                            project.sizeSuffix === 'square_feet' ?
                              <small>{t('sqft', { ns: TRANSLATION_FILES.screens })}</small>
                            : project.sizeSuffix === 'square_metres' ?
                              <small>{isVietnam ? 'm²' : t('sqm', { ns: TRANSLATION_FILES.screens })}</small>
                              : ''
                          }
                        </h1>
                        <small>{getAreaLabel(t, countryCode)}</small>
                      </div>
                    : <p className="noValue">{getMissingAreaLabel(t, countryCode)}</p>
                  }
                </Grid.Column>
                : null
            }

          {/* LAND AREA */}

          <Grid.Column>
            {
              selectUnit1 &&
              selectUnit1.landArea ?
                <div>
                  <h1>{selectUnit1.landArea || 0}</h1>
                  <small>{t('landArea', 'projectUnitLayout')}</small>
                </div>
              : <p className="noValue">{t('No land area available', { ns: TRANSLATION_FILES.translation })}</p>
            }
          </Grid.Column>
          <Grid.Column>
            {
              selectUnit2 &&
              selectUnit2.landArea ?
                <div>
                  <h1>{selectUnit2.landArea || 0}</h1>
                  <small>{translateModels(t, 'landArea', 'projectUnitLayout')}</small>
                </div>
              : <p className="noValue">{t('No land area available', { ns: TRANSLATION_FILES.translation })}</p>
            }
          </Grid.Column>
          {
              projectUnits.length >= 3 && !isMobile ?
                <Grid.Column only="computer">
                  {
                    selectUnit3 &&
                    selectUnit3.landArea ?
                      <div>
                        <h1>{selectUnit3.landArea || 0}</h1>
                        <small>{translateModels(t, 'landArea', 'projectUnitLayout')}</small>
                      </div>
                    : <p className="noValue">{t('No land area available', { ns: TRANSLATION_FILES.translation })}</p>
                  }
                </Grid.Column>
                : null
            }

          {/* BUMI */}

          <Grid.Column>
            {
              selectUnit1 ?
                <div>
                  <h1>{selectUnit1.isBumi || 'No'}</h1>
                  <small>Bumi</small>
                </div>
              : ''
            }
          </Grid.Column>
          <Grid.Column>
            {
              selectUnit2 ?
                <div>
                  <h1>{selectUnit2.isBumi || 'No'}</h1>
                  <small>Bumi</small>
                </div>
              : ''
            }
          </Grid.Column>
          {
            projectUnits.length >= 3 && !isMobile ?
              <Grid.Column only="computer">
                {
                  selectUnit3 ?
                    <div>
                      <h1>{selectUnit3.isBumi || 'No'}</h1>
                      <small>Bumi</small>
                    </div>
                  : ''
                }
              </Grid.Column>
            : null
          }

          {/* BLOCK */}

          <Grid.Column>
            {
              selectUnit1 &&
              selectUnit1.zoneOrBlock ?
                <div>
                  <h1>{selectUnit1.zoneOrBlock || ''}</h1>
                  <small>{t('Block')}</small>
                </div>
              : <p className="noValue">{t('No block available', { ns: TRANSLATION_FILES.translation })}</p>
            }
          </Grid.Column>
          <Grid.Column>
            {
              selectUnit2 &&
              selectUnit2.zoneOrBlock ?
                <div>
                  <h1>{selectUnit2.zoneOrBlock || ''}</h1>
                  <small>{t('Block')}</small>
                </div>
              : <p className="noValue">{t('No block available', { ns: TRANSLATION_FILES.translation })}</p>
            }
          </Grid.Column>
          {
            projectUnits.length >= 3 && !isMobile ?
              <Grid.Column only="computer">
                {
                  selectUnit3 &&
                  selectUnit3.zoneOrBlock ?
                    <div>
                      <h1>{selectUnit3.zoneOrBlock || ''}</h1>
                      <small>{t('Block')}</small>
                    </div>
                  : <p className="noValue">{t('No block available', { ns: TRANSLATION_FILES.translation })}</p>
                }
              </Grid.Column>
            : null
          }

          {/* LEVEL */}

          <Grid.Column>
            {
              selectUnit1 &&
              selectUnit1.streetNumberOrLevel ?
                <div>
                  <h1>{selectUnit1.streetNumberOrLevel || ''}</h1>
                  <small>{t('Level')}</small>
                </div>
              : <p className="noValue">{t('No level available', { ns: TRANSLATION_FILES.translation })}</p>
            }
          </Grid.Column>
          <Grid.Column>
            {
              selectUnit2 &&
              selectUnit2.streetNumberOrLevel ?
                <div>
                  <h1>{selectUnit2.streetNumberOrLevel || ''}</h1>
                  <small>{t('Level')}</small>
                </div>
              : <p className="noValue">{t('No level available', { ns: TRANSLATION_FILES.translation })}</p>
            }
          </Grid.Column>
          {
            projectUnits.length >= 3 && !isMobile ?
              <Grid.Column only="computer">
                {
                  selectUnit3 &&
                  selectUnit3.streetNumberOrLevel ?
                    <div>
                      <h1>{selectUnit3.streetNumberOrLevel || ''}</h1>
                      <small>{t('Level')}</small>
                    </div>
                  : <p className="noValue">{t('No level available', { ns: TRANSLATION_FILES.translation })}</p>
                }
              </Grid.Column>
            : null
          }

          {/* FACING */}

          <Grid.Column>
            {
              selectUnit1 &&
              selectUnit1.streetOrFacing ?
                <div>
                  <h1>{selectUnit1.streetOrFacing || ''}</h1>
                  <small>{t('Facing')}</small>
                </div>
              : <p className="noValue">{t('No facing available', { ns: TRANSLATION_FILES.translation })}</p>
            }
          </Grid.Column>
          <Grid.Column>
            {
              selectUnit2 &&
              selectUnit2.streetOrFacing ?
                <div>
                  <h1>{selectUnit2.streetOrFacing || ''}</h1>
                  <small>{t('Facing')}</small>
                </div>
              : <p className="noValue">{t('No facing available', { ns: TRANSLATION_FILES.translation })}</p>
            }
          </Grid.Column>
          {
            projectUnits.length >= 3 && !isMobile ?
              <Grid.Column only="computer">
                {
                  selectUnit3 &&
                  selectUnit3.streetOrFacing ?
                    <div>
                      <h1>{selectUnit3.streetOrFacing || ''}</h1>
                      <small>{t('Facing')}</small>
                    </div>
                  : <p className="noValue">{t('No facing available', { ns: TRANSLATION_FILES.translation })}</p>
                }
              </Grid.Column>
            : null
          }

        </Grid.Row>
      );
    }
    return null;
  }
  renderPrice = () => {
    const { t } = this.props;
    const { projectUnits, selectedUnit, isMobile, isMediumScreen } = this.state;
    const { selectUnit1, selectUnit2, selectUnit3 } = selectedUnit;

    if (projectUnits && selectedUnit) {
      return (
        <Grid.Row
          centered
          columns={
            isMobile ? 2
              : projectUnits.length >= 3 ?
                  isMediumScreen ?
                  2 : 3
                : 2
            }
          className="basicInfo"
        >
          <Divider horizontal>{t('Price')}</Divider>
          <Grid.Column>
            {
              selectUnit1 && selectUnit1.spaValue ?
                <div>
                  <h1>
                    <LoanAmount
                      format="0,000,000"
                      amount={selectUnit1.spaValue.toFixed(2) || 0}
                      prefix={<CurrencySymbol />}
                    />
                  </h1>
                  <small>{t('Selling Price')}</small>
                </div>
              : <p className="noValue">{t('No selling price available', { ns: TRANSLATION_FILES.translation })}</p>
            }
          </Grid.Column>
          <Grid.Column>
            {
              selectUnit2 && selectUnit2.spaValue ?
                <div>
                  <h1>
                    <LoanAmount
                      format="0,000,000"
                      amount={selectUnit2.spaValue.toFixed(2) || 0}
                      prefix={<CurrencySymbol />}
                    />
                  </h1>
                  <small>{t('Selling Price')}</small>
                </div>
              : <p className="noValue">{t('No selling price available', { ns: TRANSLATION_FILES.translation })}</p>
            }
          </Grid.Column>
          {
            projectUnits.length >= 3 && !isMobile ?
              <Grid.Column only="computer">
                {
                  selectUnit3 &&
                  selectUnit3.spaValue ?
                    <div>
                      <h1>
                        <LoanAmount
                          format="0,000,000"
                          amount={selectUnit3.spaValue.toFixed(2) || 0}
                          prefix={<CurrencySymbol />}
                        />
                      </h1>
                      <small>{t('Selling Price')}</small>
                    </div>
                  : <p className="noValue">{t('No selling price available', { ns: TRANSLATION_FILES.translation })}</p>
                }
              </Grid.Column>
                : null
          }
        </Grid.Row>
      );
    }
    return null;
  }
  renderPricingPackage = () => {
    const { t } = this.props;
    const { projectUnits, selectedUnit, isMobile, isMediumScreen } = this.state;
    const { selectUnit1, selectUnit2, selectUnit3 } = selectedUnit;

    if (projectUnits && selectedUnit) {
      return (
        <Grid.Row
          centered
          columns={
            isMobile ? 2
              : projectUnits.length >= 3 ?
                  isMediumScreen ?
                  2 : 3
                : 2
            }
          className="basicInfo"
          stretched
        >
          <Divider horizontal>{t('Pricing Packages')}</Divider>
          <Grid.Column>
            {
              selectUnit1 &&
              selectUnit1.projectUnitPackagePricings ?
                    selectUnit1.projectUnitPackagePricings.map((pp, i) => (
                      <div key={i} className="ppItemBox">
                        <h1>
                          <LoanAmount
                            format="0,000,000"
                            amount={pp.totalPrice.toFixed(2) || 0}
                            prefix={<CurrencySymbol />}
                          />
                        </h1>
                        <p>
                          {
                            pp.isCustomPrice ?
                            pp.customName :
                            pp.projectPackagePricing.name
                          }
                        </p>
                        {
                          pp.projectPackagePricing.packagePricingCalculations ?
                            pp.projectPackagePricing.packagePricingCalculations.map((ppc, idx) => (
                              <small key={idx} style={{ display: 'block' }}>
                                - {ppc.projectPackagePricingItem.name}
                              </small>
                            ))
                          : null
                        }
                      </div>
                    ))
              : <p className="noValue">{t('No pricing package available')}</p>
            }
          </Grid.Column>
          <Grid.Column>
            {
              selectUnit2 &&
              selectUnit2.projectUnitPackagePricings ?
                    selectUnit2.projectUnitPackagePricings.map((pp, i) => (
                      <div key={i} className="ppItemBox">
                        <h1>
                          <LoanAmount
                            format="0,000,000"
                            amount={pp.totalPrice.toFixed(2) || 0}
                            prefix={<CurrencySymbol />}
                          />
                        </h1>
                        <p>
                          {
                            pp.isCustomPrice ?
                            pp.customName :
                            pp.projectPackagePricing.name
                          }
                        </p>
                        {
                         pp.projectPackagePricing.packagePricingCalculations ?
                            pp.projectPackagePricing.packagePricingCalculations.map((ppc, idx) => (
                              <small key={idx} style={{ display: 'block' }}>
                                - {ppc.projectPackagePricingItem.name}
                              </small>
                            ))
                          : null
                        }
                      </div>
                    ))
              : <p className="noValue">{t('No pricing package available')}</p>
            }
          </Grid.Column >
          {
            projectUnits.length >= 3 && !isMobile ?
              <Grid.Column only="computer">
                {
                  selectUnit3 &&
                  selectUnit3.projectUnitPackagePricings ?
                        selectUnit3.projectUnitPackagePricings.map((pp, i) => (
                          <div key={i} className="ppItemBox">
                            <h1>
                              <LoanAmount
                                format="0,000,000"
                                amount={pp.totalPrice.toFixed(2) || 0}
                                prefix={<CurrencySymbol />}
                              />
                            </h1>
                            <p>
                              {
                                pp.isCustomPrice ?
                                pp.customName :
                                pp.projectPackagePricing.name
                              }
                            </p>
                            {
                              pp.projectPackagePricing.packagePricingCalculations ?
                                pp.projectPackagePricing.packagePricingCalculations.map((ppc, idx) => (
                                  <small key={idx} style={{ display: 'block' }}>
                                    - {ppc.projectPackagePricingItem.name}
                                  </small>
                                ))
                              : null
                            }
                          </div>
                        ))
                  : <p className="noValue">{t('No pricing package available')}</p>
                }
              </Grid.Column>
            : null
          }
          <Grid.Column>
            {
              selectUnit1 && selectUnit1.projectUnitPackagePricings ?
                <Button
                  content={t('View More', { ns: TRANSLATION_FILES.translation })}
                  as={Link}
                  to={`/projects/${this.props.id}/units/${selectUnit1.id}/`}
                  primary
                  target="_blank"
                  className="viewMoreButton"
                  size="tiny"
                />
              : null
            }
          </Grid.Column>
          <Grid.Column>
            {
              selectUnit2 && selectUnit2.projectUnitPackagePricings ?
                <Button
                  content={t('View More', { ns: TRANSLATION_FILES.translation })}
                  as={Link}
                  to={`/projects/${this.props.id}/units/${selectUnit2.id}/`}
                  primary
                  target="_blank"
                  className="viewMoreButton"
                  size="tiny"
                />
              : null
            }
          </Grid.Column>
          {
            projectUnits.length >= 3 && !isMobile ?
              <Grid.Column only="computer">
                {
                  selectUnit3 && selectUnit3.projectUnitPackagePricings ?
                    <Button
                      content={t('View More', { ns: TRANSLATION_FILES.translation })}
                      as={Link}
                      to={`/projects/${this.props.id}/units/${selectUnit3.id}/`}
                      primary
                      target="_blank"
                      className="viewMoreButton"
                      size="tiny"
                    />
                  : null
                }
              </Grid.Column>
            : null
          }
        </Grid.Row>
      );
    }
    return null;
  }
  renderUnitSpec = () => {
    const { t } = this.props;
    const { projectUnits, selectedUnit, isMobile, isMediumScreen } = this.state;
    const { selectUnit1, selectUnit2, selectUnit3 } = selectedUnit;

    const isUnit1MultiSpec = selectUnit1 && selectUnit1.specifications ? selectUnit1.specifications.length > 1 : null;
    const isUnit2MultiSpec = selectUnit2 && selectUnit2.specifications ? selectUnit2.specifications.length > 1 : null;
    const isUnit3MultiSpec = selectUnit3 && selectUnit3.specifications ? selectUnit3.specifications.length > 1 : null;

    if (projectUnits && selectedUnit) {
      return (
        <Grid.Row
          centered
          columns={
            isMobile ? 2
              : projectUnits.length >= 3 ?
                  isMediumScreen ?
                  2 : 3
                : 2
            }
          className="basicInfo"
        >
          <Divider horizontal>{t('Unit Specifications')}</Divider>
          <Grid.Column>
            {
              selectUnit1 && selectUnit1.specifications ?
              selectUnit1.specifications.slice(0, 10).map((spec, idx) => (
                <div
                  key={idx}
                  className={
                    isUnit1MultiSpec ?
                    'multiUnitSpec'
                    : ''
                  }
                >
                  <h1>
                    {spec.value}
                  </h1>
                  <small>{spec.name}</small>
                </div>
              ))
              : <p className="noValue">{t('No unit specifications available')}</p>
            }
          </Grid.Column>
          <Grid.Column>
            {
              selectUnit2 && selectUnit2.specifications ?
              selectUnit2.specifications.slice(0, 10).map((spec, idx) => (
                <div
                  key={idx}
                  className={
                    isUnit2MultiSpec ?
                    'multiUnitSpec'
                    : ''
                  }
                >
                  <h1>
                    {spec.value}
                  </h1>
                  <small>{spec.name}</small>
                </div>
              ))
              : <p className="noValue">{t('No unit specifications available')}</p>
            }
          </Grid.Column>
          {
            projectUnits.length >= 3 && !isMobile ?
              <Grid.Column only="computer">
                {
                  selectUnit3 && selectUnit3.specifications ?
                  selectUnit3.specifications.slice(0, 10).map((spec, idx) => (
                    <div
                      key={idx}
                      className={
                        isUnit3MultiSpec ?
                        'multiUnitSpec'
                        : ''
                      }
                    >
                      <h1>
                        {spec.value}
                      </h1>
                      <small>{spec.name}</small>
                    </div>
                  ))
                  : <p className="noValue">{t('No unit specifications available')}</p>
                }
              </Grid.Column>
                : null
          }
          <Grid.Column className="unitSpecButtonCol">
            {
              selectUnit1 && selectUnit1.specifications ?
                <Button
                  content={t('View More', { ns: TRANSLATION_FILES.translation })}
                  as={Link}
                  to={`/projects/${this.props.id}/units/${selectUnit1.id}/`}
                  primary
                  target="_blank"
                  className="viewMoreButton"
                  size="tiny"
                />

              : null
            }
          </Grid.Column>
          <Grid.Column className="unitSpecButtonCol">
            {
                selectUnit2 && selectUnit2.specifications ?
                  <Button
                    content={t('View More', { ns: TRANSLATION_FILES.translation })}
                    as={Link}
                    to={`/projects/${this.props.id}/units/${selectUnit2.id}/`}
                    primary
                    target="_blank"
                    className="viewMoreButton"
                    size="tiny"
                  />
                : null
              }
          </Grid.Column>
          {
            projectUnits.length >= 3 && !isMobile ?
              <Grid.Column only="computer" className="unitSpecButtonCol">
                {
                  selectUnit3 && selectUnit3.specifications ?
                    <Button
                      content={t('View More', { ns: TRANSLATION_FILES.translation })}
                      as={Link}
                      to={`/projects/${this.props.id}/units/${selectUnit3.id}/`}
                      primary
                      target="_blank"
                      className="viewMoreButton"
                      size="tiny"
                    />

                  : null
                }
              </Grid.Column>
            : null
          }
        </Grid.Row>
      );
    }
    return null;
  }
  render() {
    const { t } = this.props;
    const { projectUnits, isMobile } = this.state;
    const { project } = this.props;
    return (
      <Container>
        <NavBar />
        {
          projectUnits ?
            <div>
              <Grid columns={2}>
                <Grid.Row
                  centered
                  columns={
                    isMobile ? 2
                    : projectUnits ? projectUnits.length >= 3 ?
                        3 : 2
                      : null
                  }
                  className="compare_header"
                >
                  <h4>{t('Compare Units', { ns: TRANSLATION_FILES.translation })}</h4>
                  {
                    project ?
                      <p>{project.name}</p>
                    : ''
                  }
                </Grid.Row>
                {this.renderDropdown()}
              </Grid>
              {this.renderContent()}
            </div>
        : <Grid.Row>
          <Grid.Column className="noUnitCompare">
            <p>{t('No unit available', { ns: TRANSLATION_FILES.translation })}</p>
          </Grid.Column>
        </Grid.Row>
        }

      </Container>
    );
  }
}

export default withTranslation([
  ...namespaces,
  TRANSLATION_FILES.models.projectUnitLayout,
])(connect(UnitsCompare.mapStateToProps)(UnitsCompare));



// WEBPACK FOOTER //
// ./src/containers/Project/Units/UnitsCompare.jsx